import {CreationAttribute} from 'src/modules/event-create/typedefs';
import {v4 as uuidv4} from 'uuid';

export const mapTemplatesToAttributes = (
    decorationTemplate: CreationAttribute[],
    attributes: CreationAttribute[],
): CreationAttribute[] => decorationTemplate.map(attributeTemplate => ({
    ...attributeTemplate,
    attributeId: uuidv4(),
    eventId: attributes[0]?.eventId || undefined,
}));
